<template>
  <div>
    <div>
      <el-button type="default" @click="goback" size="mini" class="mb-2" icon="el-icon-arrow-left">列表</el-button>
    </div>
    <el-tree
        class="filter-tree"
        :data="cataLog"
        default-expand-all
        @node-click="handleNodeClick"
        node-key="routeName"
        highlight-current
        :current-node-key="currentNode"
        ref="tree">
    </el-tree>
  </div>
</template>

<script>
export default {
  name: "ZgCatalog",
  props: ['title', 'routeName'],
  data() {
    return {
      singlePage: ['record_zg_index', 'record_zg_gcgk', 'record_zg_hz', 'record_zg_tp', 'record_zg_09'], // 独立页面的路由，其他01-09公用一个zg页面
      cataLog: [
        {id: 1, label: '首页', routeName: 'record_zg_index',},
        {id: 2, label: '工程概况', routeName: 'record_zg_gcgk',},
        {id: 3, label: '检测结果汇总', routeName: 'record_zg_hz',},
        {id: 4, label: '01(控制电器)', routeName: 'record_zg_01',},
        {id: 5, label: '02(低压配电柜)', routeName: 'record_zg_02',},
        {id: 6, label: '03(插座照明)', routeName: 'record_zg_03',},
        {id: 7, label: '04(剩余电流)', routeName: 'record_zg_04',},
        {id: 8, label: '05(配电线路)', routeName: 'record_zg_05',},
        {id: 9, label: '06(照明器具)', routeName: 'record_zg_06',},
        {id: 10, label: '07(空调器具)', routeName: 'record_zg_07',},
        {id: 11, label: '08(接地装置)', routeName: 'record_zg_08',},
        {id: 12, label: '09(备注)', routeName: 'record_zg_09',},
        {id: 13, label: '图片', routeName: 'record_zg_tp',},
      ],
    }
  },
  computed: {
    currentNode() {
      if (this.singlePage.includes(this.$route.name)) {
        return this.$route.name;
      } else {
        return `record_zg_${this.$route.params.zg_type}`
      }
    }
  },
  methods: {
    handleNodeClick(data) {
      let routeName = 'record_zg_zg';
      if (this.singlePage.includes(data.routeName)) {
        routeName = data.routeName;
      }
      let zg_type = data.routeName.replace('record_zg_', '');
      if (zg_type !== this.$route.params.zg_type) {
        this.$router.push({
          name: routeName,
          params: {
            project_id: this.$route.params.project_id,
            site_id: this.$route.params.site_id,
            site_type: this.$route.params.site_type,
            zg_type: zg_type
          }
        })
      }
    },
    goback() {
      this.$router.push({name: this.routeName, params: this.$route.params})
    },
  }
}
</script>
<style lang="scss" scoped>
.mb-2 {
  margin-bottom: 10px;
}

.filter-tree {
  margin-right: 10px;
}

::v-deep .el-tree-node__content {
  padding: 10px 0;
}
</style>
